import { icons } from "./icons";
import { NumberConditions } from "./util";

export const iconTextMatch = {
  "=": NumberConditions.Equals,
  "≠": NumberConditions.DoesNotEqual,
  ">": NumberConditions.GreaterThan,
  "≯": NumberConditions.GreaterThanOrEqual,
  "<": NumberConditions.LessThan,
  "≮": NumberConditions.LessThanOrEqual,
};

export const data = {
  sections: [
    {
      id: "01",
      text: "Filter",
      options: [
        {
          id: "11",
          label: "clear",
          type: "clear",
          hasChild: false,
        },
        {
          id: "12",
          label: "by Text",
          type: "text",
          icon: "icon-Dropdown-2",
          hasChild: true,
          children: {
            options: ["one", "two", "three", "four"],
          },
        },
        {
          id: "13",
          label: "by Style",
          icon: "icon-Dropdown-2",
          type: "color",
          hasChild: true,
          children: {
            label: "Cell Style",
            options: [{ bgColor: "#083277" }, { bgColor: "#000000" }, { bgColor: "#7F8081" }],
          },
        },
        {
          id: "14",
          label: "by Color",
          icon: "icon-Dropdown-2",
          type: "color",
          hasChild: true,
          children: {
            label: "Cell Color",
            options: [{ bgColor: "#BCEBFF" }, { bgColor: "#FAE0FF" }, { bgColor: "#FEECB5" }],
          },
        },
        {
          id: "15",
          label: "by Font",
          icon: "icon-Dropdown-2",
          type: "color",
          hasChild: true,
          children: {
            label: "Cell Font",
            options: [{ bgColor: "#083277" }, { bgColor: "#000000" }, { bgColor: "#7F8081" }],
          },
        },
      ],
    },
    {
      id: "02",
      text: "Sort",
      options: [
        {
          id: "11",
          label: "A to Z",
          direction: "asc",
          type: "sort",
        },
        {
          id: "12",
          label: "Z to A",
          direction: "desc",
          type: "sort",
        },
        {
          id: "13",
          label: "Custom Sort",
          type: "cusSort",
        },
        {
          id: "14",
          label: "by Style",
          icon: "icon-Dropdown-2",
          type: "color",
          disabled: true,
          hasChild: false,
          children: {
            id: 2,
            label: "Font Style",
            options: [{ bgColor: "#083277" }, { bgColor: "#000000" }, { bgColor: "#7F8081" }],
          },
        },
        {
          id: "15",
          label: "by Color",
          type: "color",
          default: true,
          showAllOptions: false,
          hasChild: true,
          children: {
            label: "Cell Color",
            options: [
              { bgColor: "#F4D9F4" },
              { bgColor: "#0056CE" },
              { bgColor: "#7F8081" },
              { bgColor: "#9747FF" },
              { bgColor: "#9EBFEC" },
              { bgColor: "#ED4B33" },
              { bgColor: "#000000" },
              { bgColor: "#FFCDA5" },
              { bgColor: "#D2F0FF" },
              { bgColor: "#B6C6DB" },
              { bgColor: "#E4E6CF" },
              { bgColor: "#E4E6CF" },
              { bgColor: "#0A9046" },
              { bgColor: "#638080" },
            ],
          },
        },
        {
          id: "16",
          label: "by Font",
          type: "color",
          default: true,
          showAllOptions: false,
          hasChild: true,
          children: {
            label: "Cell Font",
            options: [{ bgColor: "#083277" }, { bgColor: "#0056CE" }, { bgColor: "#000000" }],
          },
        },
      ],
    },
  ],
  search: {
    sectionID: 4,
    id: "16",
    value: "Search",
    type: "search",
    placeholder: "Search...",
  },
  serachOptions: {
    sectionID: 5,
    type: "searchOptions",
  },
  btn: {
    label: "Apply",
  },
};

const Status = {
  Loading: 0,
  Success: 1,
  Failed: 2,
};

Object.freeze(Status);
export const Actions = Object.freeze({
  READ: "read",
  COMMENT: "comment",
  UPDATE: "update",
  CREATE: "create",
  SHARE: "share",
  MANAGE: "manage",
  DELETE: "delete",
});
export const permissionLevels = Object.freeze({
  OWNER: 60,
  ADMIN: 50,
  MANAGER: 40,
  EDITOR: 30,
  COMMENTOR: 20,
  VIEWER: 10,
  NONE: 0,
});
const CustomCursorTypes = {
  Default: 0,
  Start: 1,
  End: 2,
};
Object.freeze(CustomCursorTypes);

const PostingCellTypes = {
  Minus: "minus",
  Plus: "plus",
};
Object.freeze(PostingCellTypes);

const Direction = {
  Left: 0,
  Right: 1,
  Up: 2,
  Down: 3,
};
Object.freeze(Direction);

const hyperFormulaErrorMessages = {
  "#DIV/0!": "Division by zero. Please ensure you're not dividing by zero.",
  "#N/A": "The value is not available. The lookup value could not be found.",
  "#NAME?": "Invalid name. Please check the formula name or references.",
  "#NUM!": "Invalid number. Please check the numbers in the formula.",
  "#REF!": "Invalid reference. Please check the cell references in the formula.",
  "#VALUE!": "Wrong type of argument. Please ensure the data types are correct.",
  "#CYCLE!": "Circular reference detected. The formula is referring to its own cell.",
  "#ERROR!": "An unknown error occurred. Please review your formula.",
  "#LIC!": "Invalid license key. Please verify the license settings.",
};

const HotkeyScopes = {
  // Default
  All: "all",

  Find: "find",
  ProcessDesigner: "process-designer",
  Search: "search",
  EditToolBox: "edit-tool-box",
  Alignments: "alignments",
  Colors: "colors",
  Icons: "icons",
  CustomStyles: "custom-styles",
  SelectFont: "select-font",
  // Sidebar
  Sidebar: {
    Teams: "teams",
    Players: "players",
    Processes: "processes",
    Options: "options",
    Grids: "grids",
    Businesses: "businesses",
  },
  SidebarContextMenu: "sidebar-context-menu",
  DeleteConfirmDialog: "delete-confirm-dialog",
  NameManger: "NameManager",
  AddMemberDialog: "add-member-dialog",
  ProcessFlow: "process-flow",
  CellContextMenu: "cell-context-menu",
  goto: {
    shortcuts: "shortcuts",
    favorites: "favorites",
    search: "search",
  },
  MoreCommands: "more-commands",
  DropDown: "drop-down",
  FormulaSearch: "formula-search",
  QuickAccessToolbar: "quick-access-toolbar",
  Trash: "trash",
  GotoBox: "go-to-box",
  SeriesBox: "series-box",
  StructureTable: "structure-table",
  SmartSearch: "smart-search",
  ErrorBox: "error-box",
  FilterOptions: "fitler-options",
  FormulaBox: "formula-box",
  CustomTable: "custom-table",
  FindReplace: "find-replace",
  FilterSubMenu: "filter-sub-menu",
  CustomSort: "custom-sort",
  SelectOption: "select-option",
};
Object.freeze(HotkeyScopes);

const SubNavigations = {
  Teams: "teams",
  Players: "players",
  Processes: "processes",
  Grids: "grids",
  Options: "options",
  Styles: "styles",
  Settings: "settings",
  Businesses: "businesses",
};
Object.freeze(SubNavigations);

const ArrowTypes = {
  Parallel: "parallel",
  Normal: "normal",
};
Object.freeze(ArrowTypes);

const Positions = {
  After: "after",
  Before: "before",
  Center: "center",
};
Object.freeze(Positions);

const gotoType = {
  cell: 0,
  special: 1,
  favorites: 2,
};
Object.freeze(gotoType);

const TreeDefaultNodeIds = {
  Root: "ROOT",
  Private: "PRIVATE",
  Trash: "TRASH",
  Default: "DEFAULT",
  Sheets: "SHEETS",
};
Object.freeze(TreeDefaultNodeIds);

const ContextMenuIds = {
  Process: "PROCESS",
};
Object.freeze(ContextMenuIds);

const Preferences = {
  PanelWidth: "panelWidth",
  findReplacePositoin: "findReplacePosition",
  formulaBoxPosition: "formulaBoxPosition",
  FavoriteProcesses: "favoriteProcesses",
  FavoritePlayers: "favoritePlayers",
};
Object.freeze(Preferences);

const EditModes = {
  InnerEdit: "inner-edit",
  OuterEdit: "outer-edit",
  Disable: "disable",
};

const RowNumberWidth = 52;
const ColumnLetterHeight = 25;
const AllFonts = [
  "Roboto",
  "Arial",
  "Verdana",
  "Tahoma",
  "Trebuchet MS",
  "Times New Roman",
  "Georgia",
  "Courier New",
  "Brush Script MT",
];

const TextColors = [
  // Basic Colors
  "black",
  "white",
  "red",
  "green",
  "blue",
  "yellow",
  "cyan",
  "aqua",
  "magenta",
  "fuchsia",
  "gray",
  "grey",
  "salmon",
  "crimson",
  "pink",
  "coral",
  "tomato",
  "orange",
  "gold",
  "khaki",
  "thistle",
  "plum",
  "violet",
  "orchid",
  "lavender",
  "lime",
  "indigo",
  "purple",
  "teal",
  "moccasin",
  "navy",
  "snow",
  "azure",
  "beige",
  "ivory",
  "linen",
  "sienna",
  "brown",
  "maroon",
  "chocolate",
  "tan",
  "wheat",
  "bisque",
  "peru",
  "silver",

  // Reds
  "indianred",
  "lightcoral",
  "darksalmon",
  "lightsalmon",
  "firebrick",
  "darkred",

  // Pinks
  "lightpink",
  "hotpink",
  "deeppink",
  "palevioletred",
  "mediumvioletred",

  // Oranges
  "orangered",
  "darkorange",

  // Yellows
  "lightyellow",
  "lemonchiffon",
  "lightgoldenrodyellow",
  "papayawhip",
  "palegoldenrod",
  "darkkhaki",
  "peachpuff",

  // Purples
  "mediumorchid",
  "mediumpurple",
  "blueviolet",
  "darkviolet",
  "darkorchid",
  "darkmagenta",
  "rebeccapurple",

  // Greens
  "greenyellow",
  "chartreuse",
  "lawngreen",
  "limegreen",
  "palegreen",
  "lightgreen",
  "mediumspringgreen",
  "springgreen",
  "mediumseagreen",
  "seagreen",
  "forestgreen",
  "darkgreen",
  "yellowgreen",
  "olivedrab",
  "darkolivegreen",
  "mediumaquamarine",
  "darkseagreen",
  "lightseagreen",
  "darkcyan",

  // Blues
  "lightcyan",
  "paleturquoise",
  "aquamarine",
  "turquoise",
  "mediumturquoise",
  "darkturquoise",
  "cadetblue",
  "steelblue",
  "lightsteelblue",
  "powderblue",
  "lightblue",
  "skyblue",
  "lightskyblue",
  "deepskyblue",
  "dodgerblue",
  "cornflowerblue",
  "royalblue",
  "mediumblue",
  "darkblue",
  "midnightblue",

  // Browns
  "blanchedalmond",
  "navajowhite",
  "burlywood",
  "cornsilk",
  "rosybrown",
  "sandybrown",
  "goldenrod",
  "darkgoldenrod",
  "saddlebrown",

  // Whites
  "honeydew",
  "mintcream",
  "aliceblue",
  "ghostwhite",
  "whitesmoke",
  "seashell",
  "floralwhite",
  "antiquewhite",
  "lavenderblush",
  "mistyrose",
  "oldlace",

  // Grays
  "gainsboro",
  "lightgray",
  "lightgrey",
  "darkgray",
  "darkgrey",
  "dimgray",
  "dimgrey",
  "lightslategray",
  "lightslategrey",
  "slategray",
  "slategrey",
  "darkslategray",
  "darkslategrey",
];

const BgColors = [
  // Basic Colors
  { title: "black", code: "black" },
  { title: "white", code: "white" },
  { title: "red", code: "red" },
  { title: "green", code: "green" },
  { title: "blue", code: "blue" },
  { title: "yellow", code: "yellow" },
  { title: "cyan", code: "cyan" },
  { title: "aqua", code: "aqua" },
  { title: "magenta", code: "magenta" },
  { title: "fuchsia", code: "fuchsia" },
  { title: "gray", code: "gray" },
  { title: "grey", code: "grey" },
  { title: "salmon", code: "salmon" },
  { title: "crimson", code: "crimson" },
  { title: "pink", code: "pink" },
  { title: "coral", code: "coral" },
  { title: "tomato", code: "tomato" },
  { title: "orange", code: "orange" },
  { title: "gold", code: "gold" },
  { title: "khaki", code: "khaki" },
  { title: "thistle", code: "thistle" },
  { title: "plum", code: "plum" },
  { title: "violet", code: "violet" },
  { title: "orchid", code: "orchid" },
  { title: "lavender", code: "lavender" },
  { title: "lime", code: "lime" },
  { title: "indigo", code: "indigo" },
  { title: "purple", code: "purple" },
  { title: "teal", code: "teal" },
  { title: "moccasin", code: "moccasin" },
  { title: "navy", code: "navy" },
  { title: "snow", code: "snow" },
  { title: "azure", code: "azure" },
  { title: "beige", code: "beige" },
  { title: "ivory", code: "ivory" },
  { title: "linen", code: "linen" },
  { title: "sienna", code: "sienna" },
  { title: "brown", code: "brown" },
  { title: "maroon", code: "maroon" },
  { title: "chocolate", code: "chocolate" },
  { title: "tan", code: "tan" },
  { title: "wheat", code: "wheat" },
  { title: "bisque", code: "bisque" },
  { title: "peru", code: "peru" },
  { title: "silver", code: "silver" },

  // Reds
  { title: "indianred", code: "indianred" },
  { title: "lightcoral", code: "lightcoral" },
  { title: "darksalmon", code: "darksalmon" },
  { title: "lightsalmon", code: "lightsalmon" },
  { title: "firebrick", code: "firebrick" },
  { title: "darkred", code: "darkred" },

  // Pinks
  { title: "lightpink", code: "lightpink" },
  { title: "hotpink", code: "hotpink" },
  { title: "deeppink", code: "deeppink" },
  { title: "palevioletred", code: "palevioletred" },
  { title: "mediumvioletred", code: "mediumvioletred" },

  // Oranges
  { title: "orangered", code: "orangered" },
  { title: "darkorange", code: "darkorange" },

  // Yellows
  { title: "lightyellow", code: "lightyellow" },
  { title: "lemonchiffon", code: "lemonchiffon" },
  { title: "lightgoldenrodyellow", code: "lightgoldenrodyellow" },
  { title: "papayawhip", code: "papayawhip" },
  { title: "palegoldenrod", code: "palegoldenrod" },
  { title: "darkkhaki", code: "darkkhaki" },
  { title: "peachpuff", code: "peachpuff" },

  // Purples
  { title: "mediumorchid", code: "mediumorchid" },
  { title: "mediumpurple", code: "mediumpurple" },
  { title: "blueviolet", code: "blueviolet" },
  { title: "darkviolet", code: "darkviolet" },
  { title: "darkorchid", code: "darkorchid" },
  { title: "darkmagenta", code: "darkmagenta" },
  { title: "rebeccapurple", code: "rebeccapurple" },

  // Greens
  { title: "greenyellow", code: "greenyellow" },
  { title: "chartreuse", code: "chartreuse" },
  { title: "lawngreen", code: "lawngreen" },
  { title: "limegreen", code: "limegreen" },
  { title: "palegreen", code: "palegreen" },
  { title: "lightgreen", code: "lightgreen" },
  { title: "mediumspringgreen", code: "mediumspringgreen" },
  { title: "springgreen", code: "springgreen" },
  { title: "mediumseagreen", code: "mediumseagreen" },
  { title: "seagreen", code: "seagreen" },
  { title: "forestgreen", code: "forestgreen" },
  { title: "darkgreen", code: "darkgreen" },
  { title: "yellowgreen", code: "yellowgreen" },
  { title: "olivedrab", code: "olivedrab" },
  { title: "darkolivegreen", code: "darkolivegreen" },
  { title: "mediumaquamarine", code: "mediumaquamarine" },
  { title: "darkseagreen", code: "darkseagreen" },
  { title: "lightseagreen", code: "lightseagreen" },
  { title: "darkcyan", code: "darkcyan" },

  // Blues
  { title: "lightcyan", code: "lightcyan" },
  { title: "paleturquoise", code: "paleturquoise" },
  { title: "aquamarine", code: "aquamarine" },
  { title: "turquoise", code: "turquoise" },
  { title: "mediumturquoise", code: "mediumturquoise" },
  { title: "darkturquoise", code: "darkturquoise" },
  { title: "cadetblue", code: "cadetblue" },
  { title: "steelblue", code: "steelblue" },
  { title: "lightsteelblue", code: "lightsteelblue" },
  { title: "powderblue", code: "powderblue" },
  { title: "lightblue", code: "lightblue" },
  { title: "skyblue", code: "skyblue" },
  { title: "lightskyblue", code: "lightskyblue" },
  { title: "deepskyblue", code: "deepskyblue" },
  { title: "dodgerblue", code: "dodgerblue" },
  { title: "cornflowerblue", code: "cornflowerblue" },
  { title: "royalblue", code: "royalblue" },
  { title: "mediumblue", code: "mediumblue" },
  { title: "darkblue", code: "darkblue" },
  { title: "midnightblue", code: "midnightblue" },

  // Browns
  { title: "blanchedalmond", code: "blanchedalmond" },
  { title: "navajowhite", code: "navajowhite" },
  { title: "burlywood", code: "burlywood" },
  { title: "cornsilk", code: "cornsilk" },
  { title: "rosybrown", code: "rosybrown" },
  { title: "sandybrown", code: "sandybrown" },
  { title: "goldenrod", code: "goldenrod" },
  { title: "darkgoldenrod", code: "darkgoldenrod" },
  { title: "saddlebrown", code: "saddlebrown" },

  // Whites
  { title: "honeydew", code: "honeydew" },
  { title: "mintcream", code: "mintcream" },
  { title: "aliceblue", code: "aliceblue" },
  { title: "ghostwhite", code: "ghostwhite" },
  { title: "whitesmoke", code: "whitesmoke" },
  { title: "seashell", code: "seashell" },
  { title: "floralwhite", code: "floralwhite" },
  { title: "antiquewhite", code: "antiquewhite" },
  { title: "lavenderblush", code: "lavenderblush" },
  { title: "mistyrose", code: "mistyrose" },
  { title: "oldlace", code: "oldlace" },

  // Grays
  { title: "gainsboro", code: "gainsboro" },
  { title: "lightgray", code: "lightgray" },
  { title: "darkgray", code: "darkgray" },
  { title: "dimgray", code: "dimgray" },
  { title: "lightslategray", code: "lightslategray" },
  { title: "slategray", code: "slategray" },
  { title: "darkslategray", code: "darkslategray" },
  { title: "formuladark", code: "rgb(190,225,150)" },
  { title: "formulalight", code: "rgb(220,240,200)" },
  { title: "styledark", code: "rgb(210,185,235)" },
  { title: "stylelight", code: "rgb(235,225,245)" },
  { title: "satellitedark", code: "rgb(140,200,255)" },
  { title: "satellitelight", code: "rgb(190,225,255)" },
];
const CellIcons = [icons.Info, icons.ArrowDown, icons.Help, icons.Alert, icons.Progress, icons.AccountReactivate];
const CellIconNames = ["Info", "ArrowDown", "Help", "Alert", "Progress", "AccountReactivate"];

const keycodeToDirection = {
  ArrowLeft: "left",
  ArrowRight: "right",
  ArrowUp: "up",
  ArrowDown: "down",
};

const UndoRedoTypes = {
  RangeSelection: "RangeSelection",
};
Object.freeze(UndoRedoTypes);

export {
  Status,
  CustomCursorTypes,
  PostingCellTypes,
  Direction,
  HotkeyScopes,
  SubNavigations,
  ArrowTypes,
  Positions,
  gotoType,
  TreeDefaultNodeIds,
  ContextMenuIds,
  Preferences,
  EditModes,
  RowNumberWidth,
  ColumnLetterHeight,
  AllFonts,
  TextColors,
  BgColors,
  CellIcons,
  CellIconNames,
  keycodeToDirection,
  hyperFormulaErrorMessages,
  UndoRedoTypes,
};

// Enum for scope values
export const ScopeFilterEnum = {
  ALL: "All",
  WORKBOOK: "Names Scoped To WorkBook",
  WORKSHEET: "Names Scoped To WorkSheet",
  WITH_ERRORS: "Names With Errors",
  WITHOUT_ERRORS: "Names Without Errors",
  DEFINED_NAMES: "Defined Names",
  TABLE_NAMES: "Table Names",
};
// Named Expressions Types Enum
export const NamedExpressionsType = {
  NAMEDRANGE: "namedRange",
  TABLE: "table",
};
